import { NavLink } from 'react-router-dom';
import { useLogout } from '~/services/api/auth';
import './style.scss';
import {
  HeaderMobile,
  MenuList,
  NavItem,
  NavList,
  SideBar,
  theme,
} from 'bs-unified-ui';
import { Stack, ThemeProvider, Typography } from '@mui/material';
import LogoutIcon from '~/assets/images/icons/logout.svg';
import { Icon } from '~/components/common/Icon';
import { MenuItem } from './components/MenuItem';

type UnifiedNavbarProps = {};

export const UnifiedNavbar: React.FC<UnifiedNavbarProps> = () => {
  const { mutate: logoutMutation } = useLogout({
    onSuccess: () => {
      window.location.reload();
    },
  });

  const handleCloseSideBarMobile = () => {
    const element = document.getElementsByClassName(
      'bs-unified__side-bar-container',
    )[0] as HTMLElement;
    element?.classList.remove('bs-unified__side-bar-container-open');
  };

  return (
    <>
      <HeaderMobile />
      <SideBar
        renderHeader={
          <Stack p={1.2} mb={0.5}>
            <Typography
              fontSize={14}
              fontWeight='bold'
              fontFamily='Lato'
              color={theme.foreground.black}
            >
              Communication Hub
            </Typography>
          </Stack>
        }
        renderMenu={
          <MenuList>
            <NavLink
              to='/announcement'
              key='announcement'
              onClick={handleCloseSideBarMobile}
            >
              {({ isActive }) => (
                <MenuItem
                  icon={
                    <Icon
                      size={16}
                      name='volume-up-fill'
                      color={theme.foreground.black}
                    />
                  }
                  active={isActive}
                >
                  Announcement
                </MenuItem>
              )}
            </NavLink>
            <NavLink
              to='/content'
              key='content'
              onClick={handleCloseSideBarMobile}
            >
              {({ isActive }) => (
                <MenuItem
                  icon={
                    <Icon
                      size={16}
                      name='book-read-fill'
                      color={theme.foreground.black}
                    />
                  }
                  active={isActive}
                >
                  Content
                </MenuItem>
              )}
            </NavLink>
          </MenuList>
        }
      >
        <ThemeProvider theme={theme}>
          <NavList
            renderBottom={
              <button
                key='log-out'
                type='button'
                onClick={() => logoutMutation()}
              >
                <img width={20} height={20} src={LogoutIcon} alt='logout' />
              </button>
            }
          >
            <NavItem key='breadstack' id='breadstack' />
          </NavList>
        </ThemeProvider>
      </SideBar>
    </>
  );
};
